"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserAgentSignallingMobile = isUserAgentSignallingMobile;
exports.throttle = throttle;
var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));
function isUserAgentSignallingMobile(userAgentString) {
  var ua = (0, _uaParserJs["default"])(userAgentString);
  return ua.device.type === 'mobile';
}
function throttle(func, timeFrame) {
  var lastTime = 0;
  return function () {
    var now = new Date();
    if (now - lastTime >= timeFrame) {
      func.apply(void 0, arguments);
      lastTime = now;
    }
  };
}